import React from 'react';
import PropTypes from 'prop-types';

import Icon from '../../../components/Icon';

function TBody({
  rowData,
  columnData,
  renderCell,
  actions,
  ...props
}) {
  return (
    <tbody
      className="TrackingTableTBody"
      {...props}
    >
      {
        rowData.map(row => (
          <tr
            key={row.id}
            className={`TrackingTableTBody__tr ${row.isSelected ? ' TrackingTableTBody__tr--selected' : ''}`}
          >
            {
              columnData && columnData.map(column => (
                <td
                  key={column.name}
                  className={`TrackingTableTBody__td ${column.boldPrimary ? ' TrackingTableTBody__td--bold-primary' : ''}`}
                  style={column.style ? column.style : {}}
                >
                  {renderCell(column.name, row[column.name], row)}
                </td>
              ))
            }

            {
              actions && actions.map(action => (
                <td
                  key={action.name}
                  className="TrackingTableTBody__td TrackingTableTBody__td--edit"
                  onClick={() => { action.actionFn(row); }}
                >
                  <Icon name={action.iconName} />
                </td>
              ))
            }

          </tr>
        ))
      }
    </tbody>
  );
}

TBody.propTypes = {
  rowData: PropTypes.array,
  columnData: PropTypes.array,
  renderCell: PropTypes.func,
  onRowSelect: PropTypes.func,
};

TBody.defaultProps = {
  rowData: [],
  columnData: [],
  renderCell: () => {},
  onRowSelect: () => {},
};

export default TBody;
